import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import MoleculeVisualNav from "components/source/molecules/molecule-visual-nav";
import { visualNavContentPropType } from "../../propTypes";
import { RENTAL_INTENT } from "rtr-constants";

export class VisualNav extends React.Component {
  static propTypes = {
    filters: PropTypes.shape({
      searchText: PropTypes.string,
    }),
    path: PropTypes.string,
    visualNavContent: visualNavContentPropType,
    defaultVisualNavContentMembership: visualNavContentPropType,
    visualNavContentReserve: visualNavContentPropType,
    visualNavContentNoIntent: visualNavContentPropType,
    currentIntent: PropTypes.oneOf(Object.values(RENTAL_INTENT)),
  };

  static defaultProps = {
    visualNavContent: [],
  };

  getContent() {
    const {
      path,
      visualNavContent,
      defaultVisualNavContentMembership,
      visualNavContentReserve,
      visualNavContentNoIntent,
      currentIntent,
    } = this.props;

    if (currentIntent === RENTAL_INTENT.RESERVE && visualNavContentReserve?.length > 0) {
      return visualNavContentReserve?.find?.(content => content?.hostGrids?.includes(path));
    } else if (currentIntent === RENTAL_INTENT.NO_INTENT && visualNavContentNoIntent?.length > 0) {
      return visualNavContentNoIntent?.find?.(content => content?.hostGrids?.includes(path));
    }
    // Maintaining fall back visualNavContent. Pre-Intent based Visual Nav. Untill CMS is fully updated with
    // new intent based ones.
    return (
      defaultVisualNavContentMembership?.find?.(content => content?.hostGrids?.includes(path)) ||
      visualNavContent?.find?.(content => content?.hostGrids?.includes(path))
    );
  }

  shouldRenderVisualNav() {
    const { filters } = this.props;
    const content = this.getContent();

    return content?.products?.length >= 4 && !filters?.searchText;
  }

  render() {
    const content = this.getContent();

    if (!this.shouldRenderVisualNav()) return null;
    return (
      <MoleculeVisualNav
        products={content.products}
        isTopVisualNav={true}
        isFullBleed={content?.isFullBleed}
        visualNavSize={content?.visualNavSize || "small"}
        cardAlignment={content?.cardAlignment}
      />
    );
  }
}

const mapStateToProps = state => {
  const props = {
    filters: state.filters,
    path: state.path,
    visualNavContent: state.visualNav,
    defaultVisualNavContentMembership: state.visualNavMembership,
    visualNavContentReserve: state.visualNavReserve,
    visualNavContentNoIntent: state.visualNavContentNoIntent,
  };
  return props;
};

export default connect(mapStateToProps)(VisualNav);
